import LeaveCommunityModal from './LeaveCommunityModal';
export default LeaveCommunityModal;
